import { PureComponent } from "react";
import { StyledSocialProofComponent } from "./social-proof-component.scss";
import CompaniesLogosComponent from "components/segments/companies-logos/companies-logos-component";
import ReviewsComponent from "components/segments/reviews/reviews-component";
import SignupFormComponent from "components/core/signups/base-signup-form/signup-form-component";

export default class SocialProofComponent extends PureComponent {
  render() {
    const { CompaniesLogos, Reviews, Signup } = this.props;

    return (
      <StyledSocialProofComponent className="social-proof-component">
        <div className="companies-logos-component-wrapper">
          <CompaniesLogosComponent {...CompaniesLogos} />
        </div>

        <div className="reviews-component-wrapper">
          <ReviewsComponent {...Reviews} />
        </div>

        <div className="signup-with-decorations-component-wrapper">
          <SignupFormComponent {...Signup} />
        </div>
      </StyledSocialProofComponent>
    );
  }
}

SocialProofComponent.defaultProps = {
  CompaniesLogos: {
    paragraph: {},
    showSignup: false
  },
  Reviews: {
    columnWidth: "350px",
    reviews: [
      {
        reviewContent: [
          '"I\'ve tried... Asana, Trello, Smartsheet... I was using a combination of 3 or so at a time to accomplish everything I needed. There was a huge sigh of relief when I found monday.com."'
        ],
        reviewerName: "Dotan Egozi, monday.com"
      },
      {
        reviewContent: [
          '"I\'ve tried... Asana, Trello, Smartsheet... I was using a combination of 3 or so at a time to accomplish everything I needed. There was a huge sigh of relief when I found monday.com."'
        ],
        reviewerName: "Dotan Egozi, monday.com"
      }
    ]
  },
  Signup: {}
};
